"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupAsync = void 0;
const recipes_1 = require("../recipes");
const partition_async_1 = require("./partition-async");
const basic_reduce_ingredients_async_1 = require("./basic-reduce-ingredients-async");
exports.groupAsync = (0, recipes_1.groupRecipe)({
    ...basic_reduce_ingredients_async_1.basicReduceAsync,
    partition: partition_async_1.partitionAsync,
});
